import { DateTime } from "luxon";
import { getDeviceTimezone } from "./timezone";

/**
 * Replaces #t{{...}} placeholders in a string with a human-readable date.
 * @param text The text containing #t{{...}} placeholders.
 * @param options Optional: { timezone?: string, locale?: string }
 */
export function replaceTimePlaceholders(
  text: string,
  options?: { timezone?: string; locale?: string },
): string {
  if (!text) return text;
  return text.replace(/#t\{\{(.*?)\}\}/g, (_match, iso) => {
    let dt = DateTime.fromISO(iso, { zone: "utc" });
    if (!dt.isValid) return iso;
    if (options?.timezone) {
      const zoned = dt.setZone(options.timezone);
      if (zoned.isValid) dt = zoned;
    } else {
      // Default to device timezone
      dt = dt.setZone(getDeviceTimezone());
    }
    if (options?.locale) {
      const localized = dt.setLocale(options.locale);
      if (localized.isValid) dt = localized;
    }
    // Example format: "May 16, 2025 3:00 AM"
    return dt.toFormat("MMM d, yyyy h:mm a");
  });
}
